// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---content-page-about-mdx": () => import("./../../../content/page/about.mdx" /* webpackChunkName: "component---content-page-about-mdx" */),
  "component---content-page-home-mdx": () => import("./../../../content/page/home.mdx" /* webpackChunkName: "component---content-page-home-mdx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

